import { RandomCode } from "./Method";

export default function Model() {
  const LoginMdl = () => ({
    userName: "",
    password: "",
  });

  const PassResetMdl = () => ({
    userId: "",
    newPassword: "",
    confirmPassword: "",
  });

  const UserRoleMdl = () => ({
    id: "",
    title: "",
    subtitle: "",
    featuresAccess: "",
  });

  const PaymentsMdl = () => ({
    id: 0,
    key: RandomCode(20),
    payMethodId: "",
    amount: "",
    note: "",
    createDate: new Date().toLocaleString(),
    // Not Mapped
    methodTitle: "",
  });

  const SellPriceMdl = () => ({
    key: RandomCode(20),
    title: "",
    price: "",
  });

  const CurrMdl = () => ({
    id: "",
    symbol: "",
    currency: "",
    name: "",
    currUnit: "",
    currSubunit: "",
    isActive: true,
    createDate: new Date().toLocaleString(),

    storeId: "",
  });

  const ReturnProdMdl = () => ({
    id: "",
    sellId: "",
    items: [],
    refundAmt: 0,
    refundTaxAmt: 0,
    cutDiscount: 0,
    payableRefund: 0,
    keepRefundAsCredit: false,
    refundDate: new Date().toLocaleString(),
  });

  const MultPayMdl = () => ({
    uid: RandomCode(15),
    currId: "",
    payMethodId: 1,
    curr: "",
    amount: "",
    mainAmt: "",
    amtToPayLocal: "",
    addtlCharge: "",
    addtlChargeAmt: "",
  });

  const PayMethodMdl = () => ({
    id: "",
    title: "",
    subtitle: "",
    storeId: "",
    isAddtlCharge: false,
    addtlChargeTitle: "",
    addtlCharge: "",
    createDate: new Date().toLocaleString(),
  });

  const SupplierPaymentMdl = () => ({
    id: 0,
    purchaseId: "",
    amount: "",
    storeId: "",
    multiPayAmt: "",
    multPays: [],

    nextDueDate: "",
    payDate: new Date().toLocaleString(),
  });

  const CurrRateMdl = () => ({
    id: "",
    currId: "",
    rate: "",

    storeId: "",
    orgId: "",
  });

  const ForgotMdl = () => ({
    userName: "",
    email: "",
    forgotStep: "",
    verCode: "",
    password: "",
    confirmPass: "",
  });

  const CancelCartMdl = () => ({
    id: "",
    cancelItem: "",
    userId: "",
    storeId: "",
  });

  const CstmrMdl = () => ({
    id: 0,
    fullName: "",
    email: "",
    phone: "",
    gender: "",
    dob: "",

    specialTaxPayer: false,
    vatTax: "",
    cedulaRIFCode: "",
    taxExempt: false,

    country: "",
    city: "",
    state: "",
    zip: "",
    address1: "",
    address2: "",

    cstmrCode: "",
    company: "",

    website: "",
    twitter: "",
    note: "",
    photo: "",
    photoFile: "",
    accBalType: 2,
    balLimit: "",

    // card details
    nameOnCard: "",
    cardNumber: "",
    expiryDate: "",
    securityCode: "",

    createDate: new Date().toLocaleString(),
  });

  const OrgMdl = () => ({
    id: "",
    name: "",
    nameLocale: "",
    email: "",
    phone: "",
    currId: "",
    decimal: "",
    country: "",
    city: "",
    state: "",
    zip: "",
    address: "",
    userId: "",
    logo: "",
    logoFile: "",
  });

  const MakePayMdl = () => ({
    id: 0,
    sellId: "",
    amount: "",
    nextDueDate: "",

    userId: "",
    storeId: "",

    multPayAmt: "",
    multPays: [],
    payDate: new Date().toLocaleString(),
  });

  const PaySplrMdl = () => ({
    supplierId: "",
    purchaseId: "",
    amount: "",
    nextPayDate: "",
  });

  const SellMdl = () => ({
    id: 0,
    sellItems: [],
    payMethodId: 1,
    taxPct: "",
    discount: "",
    discountType: 1,
    subtotal: "",
    received: "",
    change: "",
    note: "",
    sellType: 1,
    dueAmt: "",
    totalPay: "",
    dueDate: "",
    creditAmt: "",
    changeAddedCredit: false,
    payments: [],
    diffAmt: "",
    taxExempt: false,
    wasSpecialTaxpayer: false,
    sellDate: new Date().toLocaleString(),

    cstmrId: "",
    userId: "",
    storeId: "",
  });

  const VoidSellMdl = () => ({
    id: 0,
    items: "",
    subtotal: "",
    userId: "",
    storeId: "",
  });

  const ProdMdl = () => ({
    id: 0,
    name: "",
    localName: "",
    barcode: "",
    categoryId: "",
    parentCatId: "",
    unit: 2,
    tax: 2,
    descr: "",
    purchPrice: "",
    sellPrices: [],
    alertQty: "",
    reOrderPoint: "",
    imgs: [],
    imgsFile: [],
  });

  const CatMdl = () => ({
    id: 0,
    name: "",
    descr: "",
    parentCatId: "",
    createDate: new Date().toLocaleString(),
  });

  const ExpsMdl = () => ({
    id: 0,
    amount: "",
    note: "",
    expenseCatId: "",
    addDate: new Date().toLocaleString(),
    addUser: "",
    storeId: "",
  });

  const PurchaseMdl = () => ({
    id: 0,
    supplierId: "",
    purchDate: new Date().toLocaleString(),
    payDate: "",
    paymentType: "",
    paymentDue: "",
    paidAmt: "",
    discount: "",
    purchItems: [],
    recept: "",
    receptFile: "",
    userId: "",
    storeId: "",
    createDate: new Date().toLocaleString(),
  });

  const PurchReturnMdl = () => ({
    id: 0,
    purchaseId: "",
    purchReturnItems: [],
    returnDate: new Date().toLocaleString(),
    userId: "",
    createDate: new Date().toLocaleString(),
  });

  const ExpensesMdl = () => ({
    id: 0,
    expsType: "",
    paybleTo: "",
    date: "",
    payment: "",
    note: "",
    doc: "",
    docFile: "",
  });

  const ExpsCatMdl = () => ({
    id: 0,
    name: "",
    descr: "",
    createDate: new Date().toLocaleString(),
  });

  const SuppliersMdl = () => ({
    id: 0,
    company: "",
    fullName: "",
    email: "",
    phone: "",
    city: "",
    state: "",
    zip: "",
    address: "",
    productSale: "",
    note: "",
    createDate: new Date().toLocaleString(),
  });

  const UserMdl = () => ({
    id: 0,
    prefix: "",
    fullName: "",
    dob: "",
    ssn: "",
    gender: "",
    phone: "",
    email: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    language: "",

    stores: [],
    userRoleId: "",
    userName: "",
    password: "",
    confirmPass: "",

    salaryType: "",
    salary: "",
    createDate: new Date().toLocaleString(),
  });

  const StockTransMdl = () => ({
    id: 0,
    date: "",
    fromStoreId: "",
    toStoreId: "",
    note: "",
    items: "",
  });

  const InventoryMdl = () => ({
    id: 0,
    productId: "",
    storeId: "",
    inInventory: "",
  });

  const PaymentMdl = () => ({
    id: 0,
    fromDate: "",
    toDate: "",
    totalHours: "",
    totalSalary: "",
    payDate: "",
    userId: "",
  });

  const StoreMdl = () => ({
    id: 0,
    storeName: "",
    storeLocalName: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    phone: "",
    tagline: "",
    email: "",
    website: "",
    socialMedia: "",
    tax: "",
    emailInvoice: 1,
    useOwnEmail: false,
    currId: "",
    salesTermForReceipt: "",

    // smtp
    emailConfig: {
      senderAddress: "",
      senderDisplayName: "",
      userName: "",
      password: "",
      host: "",
      port: "",
      createDate: new Date().toLocaleString(),
      updateDate: "",
    },

    fullName: "",
    dob: "",
    ssn: "",
    gender: "",
    mngAddress: "",
    mngCity: "",
    mngState: "",
    mngZip: "",
    mngPhone: "",

    logo: "",
    logoFile: "",

    createDate: new Date().toLocaleString(),

    // Settings Properties
    closeRegWith: 1,
    productLabel: 2,
    storeNameForReceipit: 2,
    receiptType: 1,
    receiptWidth: "58",
    enableInventoryReq: false,
    showLogoOnReceipt: false,
    showPhoneOnReceipt: false,
    showAddressOnReceipt: false,
    showStoreNameOnReceipt: false,
    showTaxOnReceipt: false,
    showTaglineOnReceipt: false,
    showEmailOnReceipt: false,
    enableSaleEdit: false,
  });

  return {
    UserRoleMdl,
    PassResetMdl,
    LoginMdl,
    ForgotMdl,
    ProdMdl,
    CatMdl,
    ExpsMdl,
    PurchaseMdl,
    PurchReturnMdl,
    ExpensesMdl,
    ExpsCatMdl,
    SuppliersMdl,
    UserMdl,
    StockTransMdl,
    InventoryMdl,
    PaymentMdl,
    StoreMdl,
    SellMdl,
    VoidSellMdl,
    CancelCartMdl,
    OrgMdl,
    CstmrMdl,
    MakePayMdl,
    CurrMdl,
    CurrRateMdl,
    PaySplrMdl,
    SupplierPaymentMdl,
    PayMethodMdl,
    MultPayMdl,
    ReturnProdMdl,
    SellPriceMdl,
    PaymentsMdl,
  };
}
